import React from "react"
import { graphql } from "gatsby"
import { App, Page, CTA, Seo } from "@sr/gatsby-theme-ui"
import { media, useMedia, useSanity } from "@sr/common"
import styled from "styled-components"
import ProductHero from "../../components/Section/Products/ProductsHubHero"
import ProductList from "../../components/Section/Products/ProductsHubListContainer"
import ProductsHubSolutionTabsMobile from "../../components/Section/Products/ProductsHubSolutionTabsMobile"
import ProductsHubSolutionTabsDesktop from "../../components/Section/Products/ProductsHubSolutionTabsDesktop"

const ProductsPage = ({ data }: any) => {
  const hero = data.sanityProductHub?.hero
  const tabs = data?.sanityProductHub?.tabs
  const productList = data.sanityProductHub?.productList
  const btnLink =
    data?.sanityProductHub?.cta?.buttonLink?.reference?.path?.current
  const ctaText = data.sanityProductHub?.cta?.title
  const btnText = data.sanityProductHub?.cta?.buttonText

  const isMobile: boolean = !useMedia(media.stUp)

  return (
    <App>
      <Page>
        <ProductsPageStyled>
          <ProductHero hero={hero} />
          {isMobile ? (
            <ProductsHubSolutionTabsMobile tabs={tabs} />
          ) : (
            <ProductsHubSolutionTabsDesktop tabs={tabs} />
          )}
          <ProductList productList={productList} />
          {btnLink && ctaText && btnText ? (
            <CTA
              header={ctaText}
              btnText={btnText}
              btnLink={btnLink}
              marginTop={[88, 112, 104]}
              maxWidth={1312}
            />
          ) : null}
        </ProductsPageStyled>
      </Page>
    </App>
  )
}

export default ProductsPage

const ProductsPageStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Head = ({ data }: any) => {
  const { imgBuilder } = useSanity()
  const sanitySeoData = data?.sanityProductHub?.seo
  let metaArray = []
  if (data?.sanityProductHub?.ogImage != undefined) {
    const src = imgBuilder(data?.sanityProductHub?.ogImage?.asset)
      .width(1200)
      .height(627)
      .auto("format")
      .crop("focalpoint")
      .url()

    metaArray.push({
      property: "og:image",
      content: src,
    })
  }

  return sanitySeoData ? (
    <Seo
      title={sanitySeoData?.seoTools?.seo_title || ""}
      noIndex={sanitySeoData?.noindex || false}
      canonical={sanitySeoData?.canonical || ""}
      keywords={sanitySeoData?.seoTools?.focus_keyword || ""}
      description={sanitySeoData?.seoTools?.meta_description || ""}
      meta={metaArray.length ? metaArray : []}
    />
  ) : null
}

export const PRODUCTSPAGE_QUERY = graphql`
  query ProductsPageQuery {
    sanityProductHub {
      seo {
        noindex
        canonical
        seoTools {
          focus_keyword
          focus_synonyms
          meta_description
          seo_title
        }
      }
      ogImage {
        asset {
          _id
        }
      }
      cta {
        buttonText
        title
        buttonLink {
          ...SanityBuilderInternalLink
        }
      }
      hero {
        buttonText
        _rawTextBlock(resolveReferences: { maxDepth: 10 })
        title
        buttonLink {
          ...SanityBuilderInternalLink
        }
        videoButtonLink
        videoButtonText
        img {
          ...SanityImageWithPreview
          alt
        }
      }
      tabs {
        title
        productHubSolutionsTabItems {
          title
          text
          solutionsTitle
          label
          img {
            ...SanityImageWithPreview
            alt
          }
          recommendedSolutions {
            recommendedSolution {
              title
              path {
                current
              }
            }
          }
        }
      }
      productList {
        features
        body
        product {
          id
          path {
            current
          }
          title
          icon
          hero {
            on
            secondaryButtonLinkType
            secondaryButtonInternalLink {
              ...SanityBuilderInternalLink
            }
            tourialId
          }
          video {
            url
            displayVideo
          }
        }
      }
    }
  }
`
